import { ROUTES } from "@/route/routes.constants";

/**
 * Navigation utility for use outside of React components (e.g., in thunks)
 * This provides React Router compatible navigation without requiring hooks
 */

export const navigateTo = (path: string) => {
  // Use window.history.pushState for React Router v6+ compatibility
  window.history.pushState(null, '', path);
  
  // Dispatch a popstate event to trigger React Router navigation
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const navigateToNotFound = () => {
  navigateTo(ROUTES.NOT_FOUND);
}; 